import React from 'react'

const Guidelines = () => {
  return (
    <div className='mx-auto p-4'>
      Guidelines
    </div>
  )
}

export default Guidelines
